import { useCallback } from 'react';

import { GA4_EVENT_ADD_TO_WISH_LIST } from '@/data/constants/gtm';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { isB2BStore, useSettings } from '@/data/Settings';
import { logEventWithValues } from '@/data/utils/logEventsUtils';
import { useMobileApp } from '@/utils/useMobileApp';
import { B2B, B2C } from 'presentation/events/constants/eventConstants';
import { useCurrentPhysicalStoreId } from 'presentation/events/hooks/useCurrentPhysicalStoreId';
import { triggerGA4EcommerceEvent } from 'presentation/events/services/ga4EcommerceService';
import { buildGA4EcommerceEventPayload } from 'presentation/events/utils/ga4Utils';
import { SendAddToWishListEventProps } from './types';

export const useTrackAddToWishListGA4 = () => {
	const { settings } = useSettings();
	const { physicalStoreId } = useCurrentPhysicalStoreId();
	const { isMobileApp } = useMobileApp();
	const isB2B = isB2BStore(settings);

	return useCallback(
		(props: SendAddToWishListEventProps) => {
			const { ga4 } = getGTMConfig(settings);

			if (!ga4 || !physicalStoreId) return;

			const { bundleId, ...eventProps } = props;

			const payload = buildGA4EcommerceEventPayload({
				event: GA4_EVENT_ADD_TO_WISH_LIST,
				settings,
				physicalStoreId,
				...eventProps,
			});

			if (bundleId) {
				payload.ecommerce.items = payload.ecommerce.items.map((item) => ({
					...item,
					bundle: 'true',
				}));
			}

			if (!isMobileApp) {
				triggerGA4EcommerceEvent(payload);
				return;
			}

			const mobilePayload = {
				...payload.ecommerce,
				app_thd: !isB2B ? B2C : B2B,
			};
			logEventWithValues(payload.event, mobilePayload);
		},
		[isB2B, isMobileApp, physicalStoreId, settings]
	);
};
